﻿import ResultType from '../enums/resultType';

/**
 * The function `getDefaultResultType` returns a default result type based on the input result type.
 * @param resultType - The `resultType` parameter is a variable that represents the type of result that
 * is being requested.
 * @returns The function `getDefaultResultType` returns a string value.
 */
const getDefaultResultType = (resultType) => {
  switch (resultType) {
    case ResultType.Locations.toString():
    case ResultType.Communities.toString():
      return ResultType.Communities.toString();

    case ResultType.Homes.toString():
      return ResultType.Homes.toString();

    case ResultType.Builders.toString():
      return ResultType.Builders.toString();

    default:
      return ResultType.Communities.toString();
  }
};

export default getDefaultResultType;
